<template>
  <textarea ref="codeEditor"></textarea>
</template>

<script>
  /* eslint-disable */
  import CodeMirror from 'codemirror'
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/mode/htmlmixed/htmlmixed'
  import 'codemirror/addon/hint/show-hint'
  import 'codemirror/addon/hint/html-hint'
  import '@/utils/minEmmet'
  import 'codemirror/addon/hint/show-hint.css'
  import 'codemirror/theme/base16-dark.css'
  import { RestoreAction } from '@/utils/utils'
  export default {
    props: {
      role: {
        type: String
      },
      actions: {
        type: Object
      }
    },
    data() {
      return {
      }
    },
    created() {
    },
    mounted: function() {
      this.initEditor()
      this.editor.setValue(this.$store.state.editorContent)
    },
    methods: {
      initEditor () {
        let _this = this;
        const editor = this.editor = CodeMirror.fromTextArea(this.$refs.codeEditor, {
          theme: 'base16-dark',
          autofocus: true,
          lineNumbers: true,
          matchBrackets: true,
          autoCloseBrackets: true,
          tabSize: 4,
          mode: 'text/html',
          line: true,
          // extraKeys: {"Tab": "autocomplete"}
        })
        this.$store.state.editor = editor
        CodeMirror.on(editor, "change", function(instance, changeObj) {
          console.log(editor.getValue())
          let codeContent = editor.getValue()
          _this.$store.commit('addAction', codeContent)
          _this.$store.state.codeContent = editor.getValue()
        });
      },
      recordAction (changeObj) {
      }
    }
  }
</script>
<style>
  .CodeMirror{
    height: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// index.vue?a334bb16